import React from "react";
import { Box, Typography, Grid, Card, CardMedia } from "@mui/material";
import BrandBgImage from "../../Images/BrandBgImage.png";
import SamsungImage from "../../Images/SamsungImage.png";
import AppleImage from "../../Images/AppleImage.png";
import VivoImage from "../../Images/VivoImage.png";
import OnePlusImage from "../../Images/OnePlusImage.png";

const brandCards = [
  {
    image: SamsungImage,
    title: "Samsung",
  },
  {
    image: AppleImage,
    title: "Apple",
  },
  {
    image: VivoImage,
    title: "Vivo",
  },
  {
    image: OnePlusImage,
    title: "OnePlus",
  },
];

export default function Brand() {
  return (
    <Box sx={{ paddingTop: 15 }}>
      {/* Full-Width Image */}
      <Box>
        <img src={BrandBgImage} alt="Brand Banner" style={{ width: "100%", display: "block" }} />
      </Box>

      {/* Section Content */}
      <Box sx={{ padding: 4, textAlign: "center", maxWidth: "1200px", margin: "0 auto" }}>
        <Typography variant="h4" sx={{ fontWeight: "bold", marginBottom: 3, color: "black" }}>
          The Brand
        </Typography>
        
        {/* Main Content */}
        <Box sx={{ textAlign: "left", maxWidth: "800px", margin: "0 auto 3rem" }}>
          <Typography 
            sx={{ 
              marginBottom: 2, 
              color: "black", 
              fontSize: '16px', 
              fontWeight: '400',
              lineHeight: 1.6
            }}
          >
            Neotel is reimagining the power of connectivity with innovation, accessibility, and reliability. 
            Rooted in Nauru and aiming to become the preferred Network of the Pacific, we are the fastest 
            5G Plus network, ensuring that individuals, businesses, and communities stay seamlessly connected, 
            no matter where they are.
          </Typography>
          
          <Typography 
            sx={{ 
              marginBottom: 2, 
              color: "black", 
              fontSize: '16px', 
              fontWeight: '400',
              lineHeight: 1.6
            }}
          >
            At our core, we bridge the digital divide, making cutting-edge technology affordable and 
            accessible to all. Through strategic partnerships and state-of-the-art security protocols, 
            we deliver high-performance, secure, and customer-centric solutions designed for the modern world.
          </Typography>
          
          <Typography 
            sx={{ 
              marginBottom: 3, 
              color: "black", 
              fontSize: '16px', 
              fontWeight: '400',
              lineHeight: 1.6
            }}
          >
            We believe in unleashing innovation to push the boundaries of what's possible, empowering 
            our customers with borderless opportunities in the digital age. Neotel is not just a network—it's 
            a future-driven ecosystem that ensures no one is left behind in the digital revolution. Wherever 
            you are, we connect you to what matters most.
          </Typography>
        </Box>

      
{/*         
        <Grid container spacing={3} justifyContent="center">
          {brandCards.map((card, index) => (
            <Grid item key={index} sx={{ display: "flex", justifyContent: "center" }}>
              <Card
                sx={{
                  width: 270,
                  boxShadow: 3,
                  textAlign: "center",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: 6,
                  }
                }}
              >
                <CardMedia 
                  component="img" 
                  height="140" 
                  image={card.image} 
                  alt={card.title}
                  sx={{
                    objectFit: "contain",
                    padding: 2
                  }}
                />
              </Card>
            </Grid>
          ))}
        </Grid> */}
      </Box>
    </Box>
  );
}